import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getCompanies, addNewsAPI } from "../../services/api.js";
import { setCompanies, saveCompany } from "../../reduxSetup/action.js";
import SpotContainer from "../../containers/SpotContainer/SpotContainer";
import PropTypes from "prop-types";

import styles from "./Table.module.scss";
import Article from "../../components/Article/Article.js";

const defaultFilter = {
  author: null,
  label: "date-inc",
};
const filterNames = ["date", "country", "author"];

const Table = ({
  setCompanies,
  organizations,
  businesses,
  government,
  media,
  saveCompany,
  hotSpot,
  greenSpot,
  news,
}) => {
  const [filter, setFilter] = useState(defaultFilter);
  const [filteredCompanies, setFilteredCompanies] = useState({
    organizations,
    businesses,
    media,
    government,
    hotSpot,
    greenSpot,
  });
  useEffect(() => {
    setFilteredCompanies({
      organizations,
      businesses,
      media,
      government,
      hotSpot,
      greenSpot,
    });
  }, [organizations, businesses, media, government, hotSpot, greenSpot]);

  useEffect(() => {
    async function fetchMyAPI() {
      const response = await getCompanies();
      setCompanies(response?.data);
    }
    fetchMyAPI();
  }, []);

  useEffect(() => {
    let allCompanies = {
      organizations,
      businesses,
      media,
      government,
      hotSpot,
      greenSpot,
    };
    if (filter.author)
      allCompanies = Object.fromEntries(
        Object.entries(allCompanies).map(([key, value]) => [
          key,
          [...value].filter((comp) => comp.author === filter.author),
        ])
      );

    if (filter.label.includes("date")) {
      setFilteredCompanies(
        Object.fromEntries(
          Object.entries(allCompanies).map(([key, value]) => [
            key,
            [...value].sort((a, b) =>
              filter.label.includes("dec")
                ? new Date(b.date) - new Date(a.date)
                : new Date(a.date) - new Date(b.date)
            ),
          ])
        )
      );
    } else {
      const filterName = filter.label.split("-")[0];
      setFilteredCompanies(
        Object.fromEntries(
          Object.entries(allCompanies).map(([key, value]) => [
            key,
            [...value].sort((a, b) => {
              if (filter.label.includes("inc")) {
                return a[filterName] === b[filterName]
                  ? 0
                  : a[filterName] > b[filterName]
                  ? 1
                  : -1;
              } else {
                return a[filterName] === b[filterName]
                  ? 0
                  : a[filterName] < b[filterName]
                  ? 1
                  : -1;
              }
            }),
          ])
        )
      );
    }
  }, [filter.author, filter.label]);

  const onSave = (company, type) => {
    /// TODO to move to SpotContainer
    /// TODO add validation
    window.confirm(
      "Are you sure you want to change? You can't redo this action"
    )
      ? saveCompany(company, type)
      : console.log("not save");
  };

  return (
    <div className={styles.container}>
      <>
        {!!filteredCompanies?.organizations?.length && (
          <>
            <h2 className={styles.companyType}> NGO</h2>
            {filteredCompanies?.organizations?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="NGO"
              />
            ))}
          </>
        )}
        {!!filteredCompanies?.businesses.length && (
          <>
            <h2 className={styles.companyType}> Business</h2>
            {filteredCompanies?.businesses?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="business"
              />
            ))}
          </>
        )}
        {!!filteredCompanies?.government.length && (
          <>
            <h2 className={styles.companyType}> Government</h2>
            {filteredCompanies?.government?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="government"
              />
            ))}
          </>
        )}
        {!!filteredCompanies?.media?.length && (
          <>
            <h2 className={styles.companyType}> Media</h2>
            {filteredCompanies?.media?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="media"
              />
            ))}
          </>
        )}
        {!!filteredCompanies?.hotSpot.length && (
          <>
            <h2 className={styles.companyType}>Hot Spot</h2>
            {filteredCompanies?.hotSpot?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="hotSpot"
              />
            ))}
          </>
        )}
        {!!filteredCompanies?.greenSpot?.length && (
          <>
            <h2 className={styles.companyType}>Green Spot</h2>
            {filteredCompanies?.greenSpot?.map((company, index) => (
              <SpotContainer
                company={company}
                key={`${company.name}${index}`}
                onSave={onSave}
                type="greenSpot"
              />
            ))}
          </>
        )}
        {!!news?.length && (
          <>
            <h2 className={styles.companyType}>News</h2>
            {news?.map((item, index) => (
              <Article
                article={item}
                key={`${item.title}${index}`}
                onSave={addNewsAPI}
                type="news"
              />
            ))}
          </>
        )}
      </>
    </div>
  );
};

Table.propTypes = {
  setCompanies: PropTypes.func,
  organizations: PropTypes.array,
  businesses: PropTypes.array,
  media: PropTypes.array,
  saveCompany: PropTypes.func,
};
Table.dafaultProps = {
  setCompanies: () => {},
  organizations: [],
  businesses: [],
  media: [],
  saveCompany: () => {},
};

const mapDispatchToProps = {
  setCompanies,
  saveCompany,
};

const mapStateToProps = ({
  companies: {
    organizations,
    businesses,
    media,
    government,
    hotSpot,
    greenSpot,
    news,
  },
}) => {
  return {
    organizations,
    businesses,
    media,
    government,
    hotSpot,
    greenSpot,
    news,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
